module.exports = __webpack_public_path__ + "static/img/why-5.89ec7cfd.jpg";